import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react'

type NetworkErrorContextValue = {
  visible: boolean
}

const NetworkErrorContext = createContext<NetworkErrorContextValue>({
  visible: false,
})

export const NETWORK_ERROR_CUSTOM_EVENT = {
  OFFLINE: 'app:network:offline',
  ONLINE: 'app:network:online',
}

export function NetworkErrorProvider (props: { children: React.ReactNode }) {
  // NetworkError是否显示：offline或“3min 无心跳”时显示
  const [visible, setVisible] = useState<boolean>(false)

  useEffect(() => {
    const handleOffline = () => setVisible(true)
    const handleOnline = () => setVisible(false)
    const handleAppOffline = () => setVisible(true)
    const handleAppOnline = () => setVisible(false)

    window.addEventListener('offline', handleOffline)
    window.addEventListener('online', handleOnline)
    window.addEventListener(NETWORK_ERROR_CUSTOM_EVENT.OFFLINE, handleAppOffline as EventListener)
    window.addEventListener(NETWORK_ERROR_CUSTOM_EVENT.ONLINE, handleAppOnline as EventListener)

    return () => {
      window.removeEventListener('offline', handleOffline)
      window.removeEventListener('online', handleOnline)
      window.removeEventListener(NETWORK_ERROR_CUSTOM_EVENT.OFFLINE, handleAppOffline as EventListener)
      window.removeEventListener(NETWORK_ERROR_CUSTOM_EVENT.ONLINE, handleAppOnline as EventListener)
    }
  }, [])

  const value = useMemo<NetworkErrorContextValue>(
    () => ({
      visible,
    }),
    [visible],
  )

  return <NetworkErrorContext.Provider value={value}>{props.children}</NetworkErrorContext.Provider>
}

export function useNetworkError () {
  return useContext(NetworkErrorContext)
}
